import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import FeatherIcon from "feather-icons-react";

const SettingModalCompanies = ({ show, onCloseClick, data }: any) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      icon: "check-circle",
      title: "Konfigurasi Cek Point",
      description: "Atur cek point aktivitas pekerjaan",
      path: `/superadmin/perusahaan/konfigurasi-cek-poin/${data._id}`,
      state: data.name,
    },
  ];

  return (
    <Modal
      size="lg"
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      //   centered={true}
      className="modern-settings-modal"
    >
      <ModalHeader className="border-0 pb-2" toggle={onCloseClick}>
        <div className="d-flex align-items-center gap-2">
          <div className="bg-primary bg-opacity-10 rounded-circle p-2">
            <FeatherIcon icon="settings" className="text-primary" size={20} />
          </div>
          <div>
            <h5 className="mb-0 fw-semibold">Pengaturan Perusahaan</h5>
            <small className="text-muted">{data?.name}</small>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="pt-3">
        <div className="settings-menu">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className="setting-item p-3 rounded-3 mb-2 border border-light cursor-pointer transition-all"
              onClick={() => {
                navigate(item.path, { state: item.state });
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.borderColor = "#dee2e6";
                e.currentTarget.style.transform = "translateX(4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.borderColor = "#f8f9fa";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div className="bg-primary bg-opacity-10 rounded-2 p-2">
                  <FeatherIcon
                    icon={item.icon}
                    className="text-primary"
                    size={24}
                  />
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-1 fw-semibold">{item.title}</h6>
                  <p className="mb-0 text-muted small">{item.description}</p>
                </div>
                <div className="text-muted">
                  <FeatherIcon icon="chevron-right" size={20} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SettingModalCompanies;
